// The Nepali (BS) date picker: Year / Month / Day selects over an AD value.
import { adToBs, bsToAd, daysInBsMonth, formatIsoDate, type CalendarDate } from '@ims/core'

/**
 * The AD date after changing one part of its BS date. The day is kept within
 * the new month (32 Asar → 31 Shrawan when Shrawan has 31 days).
 */
export function changeBsDate(iso: string, change: Partial<CalendarDate>): string {
  const bs = { ...adToBs(iso), ...change }
  bs.day = Math.min(bs.day, daysInBsMonth(bs.year, bs.month))
  return formatIsoDate(bsToAd(bs))
}
